<div class="dialog-form" style="width: 100%;">
  <p-tabView [activeIndex]="selectedTab" *ngIf="slingConfig">

    <p-tabPanel [disabled]="!pageControl || pageControl[selectedTab] !== 'data-cliente'">
      <ng-template pTemplate="header">
        <fa-icon [icon]="'ship'"></fa-icon>&nbsp;
        {{ 'SLING-DATA' | translate }}
      </ng-template>
      <ng-template pTemplate="content">
        <app-movement-data
          *ngIf="isNew || movementPlan?.id"
          [movementPlan]="movementPlan"
          [slingConfig]="slingConfig"
          [isNew]="isNew"
          [showButtons]="false"
          (cancelPageEvent)="cancel()">
        </app-movement-data>
        <app-movement-plan-objectives-form
          *ngIf="isMovementDataValid"
          [movementPlan]="movementPlan"
          [isNew]="isNew"
          [objectives]="objectives"
          [showBackButton]="false"
          (cancelPageEvent)="cancel()"
          (finishEvent)="nextPageSelectObjective($event)">
        </app-movement-plan-objectives-form>
        <app-movement-plan-objective-questionnaire
          *ngIf="currentQuestionnaire"
          [movementPlan]="movementPlan"
          [isNew]="isNew"
          [questionnaire]="currentQuestionnaire"
          (backPageEvent)="previouPage()"
          (cancelPageEvent)="cancel()"
          (finishEvent)="nextPageFromQuestionnaire($event)">
        </app-movement-plan-objective-questionnaire>
      </ng-template>
    </p-tabPanel>

    <p-tabPanel [disabled]="!pageControl || pageControl[selectedTab] !== 'navigation-plan'">
      <ng-template pTemplate="header">
        <fa-icon [icon]="'map'"></fa-icon>&nbsp;
        {{ 'Detalhes da movimentação' | translate }}
      </ng-template>
      <ng-template pTemplate="content">
        <app-movement-navigation-plan
          *ngIf="isNew || movementPlan?.id"
          [movementPlan]="movementPlan"
          [isNew]="isNew"
          [hasNavigationPlan]="objectiveSelected?.hasNavigationPlan"
          [slingConfig]="slingConfig"
          (backPageEvent)="previouPage()"
          (cancelPageEvent)="cancel()"
          (finishEvent)="nextPage($event)">
        </app-movement-navigation-plan>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</div>
